import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P204List_1({ dataTable }) {
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });

    const inputText = (rowData, value_1, value_2) => {
        let data = { ...rowData };
        let datavalue_1 = data[`${value_1}`];
        let datavalue_2 = data[`${value_2}`];
        return (
            <React.Fragment>
                <span className="p-column-title">รายละเอียด</span>
                <div className="p-fluid p-formgrid p-grid">
                    <div className="p-field p-col-12 p-md-6">
                        <InputText id="orderDetail" type="text" value={datavalue_1 != "" ? datavalue_1 : ""} disabled={true} />
                    </div>
                    {datavalue_2 !== "" ? (
                        <div className="p-field p-col-12 p-md-6">
                            <InputText id="otherDesc" type="text" value={datavalue_2 != "" ? datavalue_2 : ""} disabled={true} />
                        </div>
                    ) : null}
                </div>
            </React.Fragment>
        );
    };

    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    emptyMessage="ไม่พบข้อมูล"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column field="seqPk" header="ลำดับ" body={(e) => normalColumn(e, "seqPk", "ลำดับ")} style={{ textAlign: "center", width: "1%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="seqPk" header="รายละเอียด" body={(e) => inputText(e, "orderDetail", "otherDesc")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                </DataTable>
            </div>
        </div>
    );
}
